// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3hZSZ","emails":"CreateEditClinics_emails__j8BJ7","emailTagLabel":"CreateEditClinics_emailTagLabel__25oHO"};